import * as actionTypes from './actions';
import en from 'locales/en/messages.js';
import es from 'locales/es/messages.js';
import {DEFAULT_LOCALE} from './i18n';

let storedLocale = localStorage.getItem('locale');
const isSupportedLocale = storedLocale === 'en' || storedLocale === 'es';

const initialState = {
  language: isSupportedLocale ? storedLocale : DEFAULT_LOCALE,
  languages: {en, es},
  reload: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LANGUAGE:
      return {...state, language: action.payload};
    case actionTypes.SET_RELOAD:
      return {...state, reload: action.payload};
    default:
      return state;
  }
};

export default reducer;
